import ContentRepository from "./contentRepository";


const repositories = {
	content: ContentRepository
	
};

export const RepositoryFactory = {
	get: name => repositories[name]
}